import Reassignment from './Reassignment';
import FunctionExecution from './FunctionExecution';

export const ContextActionModal = {
  Reassignment,
  FunctionExecution,
};
